<template>
    <b-container class="mt-4" id="achievement-container">
       <div class="Header-top p-5 d-flex justify-content-between">
            <div>
                <div class="Text-name mb-2">{{name}}</div>
                <div class="Text-details">
                {{t('badges')}} {{tot_count || "0"}}
                <span v-if="tot_points">| {{t('points')}} {{tot_points}}</span>
                </div>
                <router-link to="/achievements-points"
                >Achievement Point History</router-link
                >
                <div class="share" v-if="false">
                <b-icon-upload></b-icon-upload>
                </div>
            </div>
            <div>
                <b-button @click="redirectToCouponPage()" variant="success" :disabled="redeem" v-b-tooltip.hover :title="redeem ? 'No coupons to be redeemed':''">Redeem Now</b-button>
            </div>
        </div>

        <b-row class="Badge-Container d-flex align-items-center justify-content-start py-3">
            <b-col class="Badge_Cont" v-for="user in list" v-if="list.length !== 0">
                <div class="topbar d-flex justify-content-between">
                    <div class="points">{{user.count > 1 ? user.count : ''}}</div>
                    <div>
                        <b-button class="info" v-b-tooltip.hover :title="user.description" v-if="user.description">
                            <b-icon icon="info-circle" scale="2" variant="info"></b-icon>
                        </b-button>
                    </div>
                </div>
                
                <div class="Badge shadow mt-3">
                        
                        <div class="Badge_image">
                            <img :src="user.image" height="100%" width="100%" v-if="!!user.image" />
                            <img src="../../module_b2b_users/assets/images/achievements.png" height="100%" width="100%" v-else />
                            <div></div>
                        </div>
                        <div class="Badge-details">
                            <div class="Badge_name" v-b-tooltip.hover :title="user.name">{{user.name}}</div>
                            <div class="Badge_points" v-if="user.total_points > 0">{{t('points')}}: {{user.total_points}}</div>
                            <div class="Badge_day" v-if="user.count != 0">
                                <div v-if="dateDiff(new Date(), new Date(user.createdAt)) !== 0">{{dateDiff(new Date(), new Date(user.createdAt))}} {{t('days_ago')}}</div>
                                <div v-else>{{t('today')}}</div>
                                <div>{{d(user.createdAt, 'short')}}</div>
                            </div>
                        </div>
                        <div class="bg-green"></div>
                        <b-progress
                            :value="user.completed_percentage"
                            :max="100"
                            v-if="user.has_progress_bar"
                            v-b-tooltip.hover 
                            :title="user.progress_message"
                            animated
                        ></b-progress>
                    </div>
                    <!-- <div style="height: 1rem;">
                        <b-progress value="50" max="100" class="m-2" v-if="showProgressBar(user)"></b-progress>
                    </div> -->
            </b-col>
            <div class="d-flex align-items-center justify-content-center no_achievements flex-column" v-if="list.length === 0">
                <div class="icon" >
                    <b-icon-trophy />
                </div>
                <h2 class="text-center">
                    {{t('no_achievements')}}
                </h2>
                <p class="text-center w-75">
                    {{t('no_achievements_desc')}}
                </p>
                <router-link :to="'/user/discover'" class="btn btn-primary respbtn p-2"> {{t('start_journey')}}</router-link>
            </div>
        </b-row>
    </b-container>
</template>

<script>
import api from "@/module_dashboard/api.js";
import { i18nComponentMixin } from "@/i18n/mixin";
export default {
name: "Achievements",
data: function(){
    return {
        list: [],
        tot_count: 0,
        width: 0,
        tot_points: 0,
        name: '',
        page : 0,
        pageSize : 30,
        isLoading : false,
        redeem: true
    }
},
mixins:[i18nComponentMixin('views/Achievements')],
methods: {
    redirectToCouponPage(){
        this.$router.push('/redeem')
    },
    dateDiff(date1, date2){
        let utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
        let utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

        let timeDiff = Math.abs(utc2 - utc1);

        return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    },
    showProgressBar(achievement){
        if(achievement.is_one_time){
            return achievement.count == 0
        }
        return !achievement.is_deleted
    },
    async  loadAchievementData() {
        if (this.isLoading) {
            return;
        }
        if (this.page > 0) {
            if (this.tot_count == this.list.length) {
            return;
            }
        }
        this.page++;
        try {
            this.isLoading = true;

            const badges = (
            await api.getAchievementData({ page: this.page, pageSize: this.pageSize })
            )?.data;
            this.list = [...this.list, ...badges["achievementList"]];
            // this.list[7].completed_percentage = 75;
            this.tot_count = badges.total;
            this.tot_points = badges.points;
            this.name =
            JSON.parse(localStorage.getItem("userInfo"))?.name ||
            (JSON.parse(localStorage.getItem("userInfo"))?.email.split("@"))[0];
        } catch (error) {
            console.log(error)
        }
        this.isLoading = false;
    },

    async handleScroll({ target: { scrollTop, clientHeight, scrollHeight }}) {
      if (scrollTop + clientHeight+50 >= scrollHeight) {
        await this.loadAchievementData();
      }
    }
},
async mounted(){
    await this.loadAchievementData();
    document.querySelector("#achievement-container").addEventListener("scroll", this.handleScroll);
    const cou = (await api.getCouponData()).data;
    if(cou.length > 0) this.redeem =  false;
    else this.redeem =  true;
},
beforeDestroy() {
    document.querySelector("#achievement-container").removeEventListener("scroll", this.handleScroll);
}
}

</script>

<style lang="scss" scoped>

.Header-top{
    background-color: #EAEAEA;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    position: relative;

    .Text-name{
        font-size: 50px;
        color: #404040;
        font-weight: bold;
        line-height: 40px;
    }

    .Text-details{
        font-size: 25px;
        color: #404040;
        font-weight: light;
    }
}

#achievement-container{
    overflow: scroll;
    height: 100%;
}
::v-deep .progress{
    width: calc(100% - 4px);
    position: absolute;
    bottom: 2px;
    z-index: 8;
    border-radius: 10px !important;
    background-color: #90D7A4;
    box-shadow: 0 0 0 2px rgba(255,255,255,0.8);
    color: #fff;
}
::v-deep .progress-bar{
        background-color: #20b0a5;
    }
.Badge_Cont{
    position: relative;
    max-width: 240px;
    min-width: 200px;

    .topbar{
        position: absolute;
        width: 75%;
        left: 12%;
        top: 7%;
        z-index: 1;
    }

    .points{
        z-index: 1;
        cursor: pointer;
        width: fit-content;
        font-weight: 700;
    }

    .info{
        z-index: 1;
        cursor: pointer;
        background-color: transparent;
        border: none;
        box-shadow: none !important;
    }
}


.share{
    padding: 10px 15px;
    border-radius: 50%;
    font-size: 1.2rem;
    background-color: #28C76F;
    color: #fff;
    position: absolute;
    top: 5px;
    right: 5px;
}


.Badge{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    height: 240px;
    overflow: hidden;
    border-radius: 12px;
    background-color: #fff;
    position: relative;

    .Badge_image{
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        border: 10px solid #fff;
        z-index: 2;
        background-color: white;
        height: 150px;
        width: 150px;
    }

    .Badge-details{
        color: #fff;
        background-color: transparent;
        width: 100%;
        position: absolute;
        z-index: 4;
        top: 100px;
        padding-top: 50px;
        padding-bottom: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .Badge_name{
            font-weight: bold;
            width: 100%;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding: 0 9px;
        }
        .Badge_points{
            font-weight: light;
        }
        .Badge_day{
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 0.8rem;
            gap: 20px;
        }
    }

    .bg-green{
        background: linear-gradient(135deg, #28C76F, #20B07F);
        position: absolute;
        top: 120px;
        width: 100%;
        height: 60%;
    }
}
.no_achievements{
    color: #AFB1B6;

    .icon{
        font-size: 13rem;
    }
    p{
        font-size: 1.2rem;
    }
}

.respbtn{
    width: 25%;
}

@media screen and (max-width: 426px){
    .Header-top .Text-name{
        font-size: 37px;
    }
    .Header-top .Text-details{
        font-size: 22px;
    }
    .respbtn{
        width: 80%;
    }
}

@media screen and (max-width: 768px){
    .Header-top{
        flex-direction: column;
    }
}

</style>